import { Record } from "immutable";

import createFromJS from "../../../createFromJS";
import { DateRecord } from "../../model/data/DateRecord";

export const CalendarMarkerDisplayRecord = Record({
  // Normal properties of Event
  id: null,
  label: null,
  color: null,
  icon: null,
  drawOnTimeline: false,
  // Display extensions
  startDate: DateRecord(),
  endDate: DateRecord()
});

const data = {
  objects: {
    startDate: "DateRecord",
    endDate: "DateRecord"
  }
};
createFromJS.registerCallback(
  "CalendarMarkerDisplayRecord",
  createFromJS.createNestedCallback(CalendarMarkerDisplayRecord, data)
);
